import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useDocumentAccountLockedListData, useGetEmployeeStatusData } from "./hooks/useEmployee";
type Props = {};



const documentAccountBalanceData = [
  {
    id: 1,
    employeeid: "Sample",
    leaveyear: "Sample",
    leavetype: "Sample",
    accuration: "Sample",
    opening: "Sample",
    reward: "Sample",
    consumed: "Sample",
    balance: "Sample",
  },
  {
    id: 2,
    employeeid: "Sample",
    leaveyear: "Sample",
    leavetype: "Sample",
    accuration: "Sample",
    opening: "Sample",
    reward: "Sample",
    consumed: "Sample",
    balance: "Sample",
  },
  {
    id: 3,
    employeeid: "Sample",
    leaveyear: "Sample",
    leavetype: "Sample",
    accuration: "Sample",
    opening: "Sample",
    reward: "Sample",
    consumed: "Sample",
    balance: "Sample",
  },
  {
    id: 4,
    employeeid: "Sample",
    leaveyear: "Sample",
    leavetype: "Sample",
    accuration: "Sample",
    opening: "Sample",
    reward: "Sample",
    consumed: "Sample",
    balance: "Sample",
  },
  {
    id: 5,
    employeeid: "Sample",
    leaveyear: "Sample",
    leavetype: "Sample",
    accuration: "Sample",
    opening: "Sample",
    reward: "Sample",
    consumed: "Sample",
    balance: "Sample",
  },
];

const DocumentAccountLocked = (props: Props) => {
  const [filtersState, setfiltersState] =  useState<any>({
      limit: 10,
      page: 1,
      search: null,
      status: null,
    });

    const { data: DocumentAccountLockedListData } = useDocumentAccountLockedListData({
      params: {
        limit: filtersState.limit,
        page: filtersState.page,
        search: filtersState.search,
        status: filtersState.status,
      },
      enable: true,
    });
    const { data: employeeStatus } = useGetEmployeeStatusData({ enable: true });
    const DocumentAccountLockedData = DocumentAccountLockedListData?.data;


      const employeeListColumns = [
    {
      name: "Employee Code",
      selector: (row: { EmployeeCode: number | string }) =>
        row.EmployeeCode || "-",
      sortable: true,
    },
    {
      name: "First Name",
      selector: (row: { FirstName: string }) => row.FirstName || "-",
      sortable: true,
    },
    {
      name: "Last Name",
      selector: (row: { LastName: string }) => row?.LastName || "-",
      sortable: true,
    },
    {
      name: "HQ",
      selector: (row: { Stownname: string }) => row?.Stownname || "-", // (depend by backend)
      sortable: true,
    },
    {
      name: "Organization",
      selector: (row: { UnitName: string }) => row?.UnitName || "-", // (depend by backend)
      sortable: true,
    },
    {
      name: "Grade",
      selector: (row: { GradeName: string }) => row?.GradeName || "-",
      sortable: true,
    },
    {
      name: "Designation",
      selector: (row: { Designation: string }) => row?.Designation || "-",
      sortable: true,
    },
    {
      name: "Join Date",
      selector: (row: { JoinDate: string }) => row.JoinDate || "-", // need to add (depend by backend)
      sortable: true,
    },
    {
      name: "Employee Status",
      selector: (row: { Status: any }) =>
        employeeStatus?.["response"]?.[row.Status], // employeeStatus?.['response']?.[row.Status]
      sortable: true,
    },
   
  ];

    const handlePagination = (pageNo: number) => {
    setfiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setfiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setfiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };
    const handleFilter = (key: any, selected: any) => {
      setfiltersState((prev: any) => ({
        ...prev,
        [key]: selected.id == "null" ? null : Number(selected.id),
      }));
      console.log(filtersState)
    };

  return (
    <div className="p-2">
      <PageHeader
        title="Document Account Locked"
        buttons={[
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
          {
            label: "CSV",
            onClick: () => alert("Action 3 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Employee"
         paginationTotalRows={
              DocumentAccountLockedData?.Pagination?.TotalEmployees || 0
            }
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            handleSearch={(val: any) => {
              handleSearch(val);
            }}
        data={DocumentAccountLockedData?.Employees||[]}
        columns={employeeListColumns}
        headerContent={
          <RoundedDropdown
            options={employeeStatus?.data || []}
            onSelect={(e: any) => {
             handleFilter("status", e)
            }}
            defaultLabel="All"
            width="auto"
            isShowHeading
            DropdownHeading="Employee"
            headingColor="#2e8dd3"
          />
        }
      />
    </div>
  );
};

export default DocumentAccountLocked;
